module.exports = __webpack_public_path__ + "img/Priest-draenei-f-70.32b21678.gif";